module.exports = __webpack_public_path__ + "static/media/exit1.d0b553d6.svg";